export class CreateNewPasswordModel {
  email: string = "";
  old_password: string = "";
  new_password: string = "";
  confirm_password: string = "";

  constructor(data?: Partial<CreateNewPasswordModel>) {
    Object.assign(this, data); // Merge existing user data safely
  }
}
    